const route = [
    // 单点登陆
    {
        path: '/tripartiteLogin',
        name: 'tripartiteLogin',
        component: () => import('@/pages/tripartiteLogin')
    },
    //第三方登陆
    {
        path: '/ssologin',
        name: 'ssologin',
        component: () => import('@/pages/ssoLogin')
    },
    //i教育研修登陆
    {
        path: '/yxlogin',
        name: 'yxlogin',
        component: () => import('@/pages/yxLogin')
    },
    //工业单点登陆
    {
        path: '/gylogin',
        name: 'gylogin',
        component: () => import('@/pages/gyLogin')
    },
    //翔安教师队伍系统单点登陆
    {
        path: '/xassologin',
        name: 'xassologin',
        component: () => import('@/pages/xassoLogin')
    },
    //i厦大单点登陆
    {
        path: '/ixiadalogin',
        name: 'ixiadalogin',
        component: () => import('@/pages/ixiadaLogin')
    },
    //黎大单点登陆
    {
        path: '/lmulogin',
        name: 'lmulogin',
        component: () => import('@/pages/lmuLogin')
    },
    //福州鼓楼教育局单点登陆
    {
        path: '/gllogin',
        name: 'gllogin',
        component: () => import('@/pages/glLogin')
    },
    //夏商移动端单点登陆
    {
        path: '/xsmlogin',
        name: 'xsmlogin',
        component: () => import('@/pages/xsmLogin')
    },
    //夏商PC端单点登陆
    {
        path: '/xsplogin',
        name: 'xsplogin',
        component: () => import('@/pages/xspLogin')
    },
    //双十单点登陆
    {
        path: '/xmsslogin',
        name: 'xmsslogin',
        component: () => import('@/pages/xmsslogin')
    },
    //集美教育局单点登陆
    {
        path: '/jmjyjlogin',
        name: 'jmjyjlogin',
        component: () => import('@/pages/jmjyjlogin')
    },
    //集美手机端单点登陆
    {
        path: '/jmplogin',
        name: 'jmplogin',
        component: () => import('@/pages/jmpLogin')
    },
    //学生资助单点登陆
    {
        path: '/xszzlogin',
        name: 'xszzlogin',
        component: () => import('@/pages/xszzLogin')
    },
    //同安新星学校单点登陆
    {
        path: '/taxxplogin',
        name: 'taxxplogin',
        component: () => import('@/pages/taxxpLogin')
    },
    //疫情防控单点登陆
    {
        path: '/yqfklogin',
        name: 'yqfklogin',
        component: () => import('@/pages/yqfkLogin')
    },
    //企业微信单点登录
    {
        path: '/qywxlogin',
        name: 'qywxlogin',
        component: () => import('@/pages/qywxLogin')
    },
    //龙岩单点登陆
    {
        path: '/lylogin',
        name: 'lylogin',
        component: () => import('@/pages/lyLogin')
    },
    //龙岩空间单点登陆
    {
        path: '/lyplatformlogin',
        name: 'lyplatformlogin',
        component: () => import('@/pages/lyplatformLogin')
    },
    //龙岩单点登陆-跳转指定场景页
    {
        path: '/lycustomlogin',
        name: 'lycustomlogin',
        component: () => import('@/pages/lycustomLogin')
    },
    //龙岩教育局角色授权
    {
        path: '/roleauth',
        name: 'roleauth',
        component: () => import('@/pages/roleAuth')
    },
    {
        path: '/school',
        name: 'dsblogin',
        component: () => import('@/pages/dsbLogin')
    },
    {
        path: '/qrcodelogin',
        name: 'qrcodelogin',
        component: () => import('@/pages/qrcodeLogin')
    },
    {
        path: '/wxlogin',
        name: 'wxlogin',
        component: () => import('@/pages/wxLogin')
    },
]

export default route